import React, { useContext } from 'react';
import styled from 'styled-components';

import AddGroupInput from './AddGroupInput';
import CurrentGroups from './CurrentGroups';
import ConfigureMicrosoftSsoContext from '../contexts/ConfigureMicrosoftSsoContext';

const AddGroupCardDiv = styled.div<{ hasGroups: boolean }>`
  border-radius: 6px;
  background-color: var(--color-bg-muted);
  padding: 16px;
  box-shadow: ${(props) =>
    props.hasGroups ? 'var(--shadow-sm) inset' : 'unset'};
  border: 1px solid var(--color-grey-7);
`;

const GroupInputCard = () => {
  const { selectedGroups } = useContext(ConfigureMicrosoftSsoContext);

  return (
    <AddGroupCardDiv hasGroups={selectedGroups.length > 0}>
      <AddGroupInput />
      {selectedGroups.length > 0 && <CurrentGroups />}
    </AddGroupCardDiv>
  );
};

export default GroupInputCard;
